import { DateTime } from 'luxon'

export const formatDate = (date) =>
  date ? DateTime.fromISO(date).toFormat('yyyy-MM-dd') : ''
